import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";

export default function TestimonialSlider() {
  return (
    <section>
      <div className="container">
        <div className="testimonial-arrow swiper-btn-custom d-flex flex-row-reverse">
          <div
            className="swiper-slider testimonail-section-one"
            data-arrows-classname="testimonial-arrow"
            data-loop="true"
            data-autoplay="true"
            data-dots="false"
            data-arrows="true"
            data-columns="1"
            data-margin="30"
            data-effect="slide"
          >
            {/* Swiper wrapper */}
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation
              loop={true}
              // autoplay={{ delay: 15000, disableOnInteraction: false }}
              spaceBetween={30}
              slidesPerView={1}
            >
              <SwiperSlide>
                <article className="pbmit-testimonial-style-1">
                  <div className="pbminfotech-post-item d-flex">
                    <div className="pbminfotech-box-img">
                      <div className="pbmit-featured-img-wrapper">
                        <div className="pbmit-featured-wrapper">
                          <img
                            src={"assets/images/daily/v1.png"}
                            className="img-fluid"
                            alt={"no"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="pbminfotech-box-content">
                      <div className="pbminfotech-testimonial-wrapper">
                        <div className="pbminfotech-box-desc">
                          <blockquote className="pbminfotech-testimonial-text">
                            <div className="at-above-post-homepage addthis_tool"></div>
                            <p>
                              <strong>Coach Elite</strong>
                              <br />
                              <br />
                              Body First Performance Coaching for Clarity,
                              Consistency, and Results Without Burnout
                              <br />
                              <br />
                              Coach Elite helps professionals and high
                              performing individuals build physical capacity,
                              mental focus, and disciplined execution through
                              coach led fitness integration and performance
                              based routines.
                              <br />
                              <br />
                              <strong>
                                👉{" "}
                                <Link to="/clarity-call">
                                  Apply for Founding Client Coaching
                                </Link>
                              </strong>
                              <br />
                              <br />
                              Submit your details and our team will reach out to
                              you personally. You’ll receive a confirmation
                              email, and we will schedule a call with you.
                            </p>

                            <div className="at-below-post-homepage addthis_tool"></div>
                          </blockquote>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </SwiperSlide>
              <SwiperSlide>
                <article className="pbmit-testimonial-style-1">
                  <div className="pbminfotech-post-item d-flex">
                    <div className="pbminfotech-box-img">
                      <div className="pbmit-featured-img-wrapper">
                        <div className="pbmit-featured-wrapper">
                          <img
                            src={"assets/images/daily/v2.png"}
                            className="img-fluid"
                            alt={"no"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="pbminfotech-box-content">
                      <div className="pbminfotech-testimonial-wrapper">
                        <div className="pbminfotech-box-desc">
                          <blockquote className="pbminfotech-testimonial-text">
                            <div className="at-above-post-homepage addthis_tool"></div>
                            <p>
                              The Coach Elite Approach
                              <br />
                              <br />
                              Most performance coaching starts with mindset.
                              <br />
                              Coach Elite starts with the body.
                              <br />
                              <br />
                              We first build physical capacity—strength,
                              conditioning, and recovery—to regulate energy,
                              focus, and stress response.
                              <br />
                              <br />
                              This physical foundation supports:
                              <br />
                              <br />
                            </p>

                            <ul>
                              <li>• Clearer thinking</li>
                              <li>• Stronger routines</li>
                              <li>
                                • Calm, consistent execution under pressure
                              </li>
                            </ul>

                            <br />

                            <p>
                              No extremes.
                              <br />
                              No burnout cycles.
                              <br />
                              No motivation hacks.
                              <br />
                              <br />
                              <i>When the body stabilizes, the mind follows.</i>
                            </p>

                            <div className="at-below-post-homepage addthis_tool"></div>
                          </blockquote>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </SwiperSlide>
              <SwiperSlide>
                <article className="pbmit-testimonial-style-1">
                  <div className="pbminfotech-post-item d-flex">
                    <div className="pbminfotech-box-img">
                      <div className="pbmit-featured-img-wrapper">
                        <div className="pbmit-featured-wrapper">
                          <img
                            src={"assets/images/daily/v3.png"}
                            className="img-fluid"
                            alt={"no"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="pbminfotech-box-content">
                      <div className="pbminfotech-testimonial-wrapper">
                        <div className="pbminfotech-box-desc">
                          <blockquote className="pbminfotech-testimonial-text">
                            <div className="at-above-post-homepage addthis_tool"></div>
                            <p>
                              Who This Is For &amp; How We Work
                              <br />
                              <br />
                              Coach Elite is designed for professionals who feel
                              mentally overloaded, physically depleted, or stuck
                              in performance burnout cycles and want
                              sustainable, repeatable high performance.
                              <br />
                              <br />
                              Choose your path:
                              <br />
                              <br />
                            </p>

                            <ul>
                              <li>
                                • Full performance coaching integrating fitness,
                                mental clarity, leadership, and disciplined
                                execution
                              </li>
                              <li>
                                • Fitness focused coaching to build physical
                                capacity, energy, and resilience that supports
                                peak performance in all areas
                              </li>
                              <li>
                                • Or a personalized blend tailored to your
                                unique goals and lifestyle
                              </li>
                            </ul>

                            <br />

                            <p>
                              We work closely with a small group of founding
                              clients, enabling:
                              <br />
                              <br />
                            </p>

                            <ul>
                              <li>• Personalized coaching</li>
                              <li>• Structured, fitness led routines</li>
                              <li>
                                • Focused development of a high performance
                                system
                              </li>
                            </ul>

                            <br />

                            <p>
                              <strong>
                                👉{" "}
                                <Link to="/clarity-call">
                                  Book a Clarity Call
                                </Link>
                              </strong>
                              <br />
                              <br />
                              Submit your details and our team will reach out to
                              you personally.
                              <br />
                              <br />
                              <i>Required details:</i>
                              <br />
                              • Client Name
                              <br />
                              • Email ID
                              <br />
                              • Phone Number
                              <br />• What you are looking to achieve
                            </p>

                            <div className="at-below-post-homepage addthis_tool"></div>
                          </blockquote>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}
